/* ────────────────────────────────────────────────────────────────────────
   Cart currency re-sync
   ------------------------------------------------------------------------
   Custom-priced line items (murals / made-to-measure wallpaper) store their
   price in two properties:
     _custom_price      → presentment (market) currency cents, frozen at add
     _custom_price_usd  → canonical USD cents, market-independent

   A Shopify Cart Transform Function reads _custom_price and charges that
   exact number AS the line price in the active market currency. So if a
   customer adds in USA ($23 → 2300) then switches to Canada, the frozen
   2300 is charged as CA$23 instead of the correct CA$32.66 — a revenue leak.

   This script runs on the cart page and, for each custom line, recomputes
   _custom_price = round(_custom_price_usd × currentMarketRate). If it differs
   from the stored value (i.e. the market changed since the item was added),
   it patches the line via /cart/change.js and reloads once. After the reload
   the values match, so it does nothing further (self-terminating).
   ──────────────────────────────────────────────────────────────────────── */
(function () {
  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function currentRate() {
    var r = window.Shopify && window.Shopify.currency && window.Shopify.currency.rate;
    var n = parseFloat(r);
    return (isFinite(n) && n > 0) ? n : 1;
  }

  async function resync() {
    var rate = currentRate();
    var res, cart;
    try {
      res = await fetch(rootUrl() + 'cart.js', { headers: { 'Accept': 'application/json' } });
      cart = await res.json();
    } catch (e) { return; }
    if (!cart || !Array.isArray(cart.items) || !cart.items.length) return;

    var changes = [];
    cart.items.forEach(function (item, idx) {
      var props = item.properties || {};
      var usd = parseInt(props._custom_price_usd, 10);
      if (!usd || isNaN(usd)) return;                 // not a re-convertible line
      var current = parseInt(props._custom_price, 10);
      var desired = Math.round(usd * rate);
      if (desired === current) return;                // already correct for this market
      // Merge: preserve every existing property, override the two price fields.
      var merged = Object.assign({}, props, { _custom_price: String(desired) });
      changes.push({ line: idx + 1, properties: merged });
    });

    if (!changes.length) return;

    // Apply sequentially so each change.js sees a stable line ordering.
    for (var i = 0; i < changes.length; i++) {
      try {
        await fetch(rootUrl() + 'cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(changes[i])
        });
      } catch (e) { /* keep going; a partial fix is better than none */ }
    }

    // Reload so Liquid re-renders line prices + summary totals from the
    // corrected _custom_price. Stable: re-run finds no mismatch → no reload.
    window.location.reload();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', resync);
  } else {
    resync();
  }
})();
